var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-card",
    {
      staticClass: "mt-3 p-0",
      attrs: {
        "no-body": "",
        "footer-bg-variant": "white",
        "footer-border-variant": "white",
      },
    },
    [
      _c(
        "b-card-header",
        {
          staticClass: "p-0 ml-3 mr-3",
          attrs: { "header-text-variant": "white" },
        },
        [
          !_vm.componenteVisible
            ? _c(
                "b-row",
                {
                  staticClass: "p-4",
                  staticStyle: {
                    "border-radius": "1.5rem",
                    "background-color": "#611232",
                  },
                },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-icon", {
                        staticClass: "i-selected",
                        attrs: { "font-scale": "1.2", icon: "plus-square" },
                        on: {
                          click: function ($event) {
                            _vm.componenteVisible = true
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "font-weight-bold ml-3",
                        staticStyle: { "font-size": "1.5rem" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("apeironGwApp.finiquito.title")
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "b-row",
                {
                  staticClass: "p-4",
                  staticStyle: {
                    "border-top-left-radius": "1.5rem",
                    "border-top-right-radius": "1.5rem",
                    "background-color": "#611232",
                  },
                },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-icon", {
                        staticClass: "i-selected",
                        attrs: { "font-scale": "1.2", icon: "dash-square" },
                        on: {
                          click: function ($event) {
                            _vm.componenteVisible = false
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "font-weight-bold ml-3",
                        staticStyle: { "font-size": "1.5rem" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("apeironGwApp.finiquito.title")
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          model: {
            value: _vm.componenteVisible,
            callback: function ($$v) {
              _vm.componenteVisible = $$v
            },
            expression: "componenteVisible",
          },
        },
        [
          _c(
            "b-card-body",
            { staticClass: "mr-4 ml-4" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-overlay",
                        {
                          attrs: {
                            show: _vm.isSearching,
                            "spinner-variant": "primary",
                          },
                        },
                        [
                          _c("b-table", {
                            staticClass: "text-nowrap mt-3",
                            attrs: {
                              responsive: "",
                              "sticky-header": "70vh",
                              "show-empty": "",
                              "head-variant": "primary",
                              fields: _vm.campos,
                              items: _vm.pagos,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "empty",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-row",
                                      { attrs: { "align-h": "center" } },
                                      [
                                        _c("b-col", { attrs: { cols: "4" } }, [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.finiquito.mensaje.sinResultados"
                                                )
                                              ),
                                            },
                                          }),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.totalRows > 0
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "4" } },
                        [
                          _c("b-form-select", {
                            staticClass: "w-25",
                            attrs: { size: "sm", options: _vm.perPageOptions },
                            on: { change: _vm.handlePageSizeChange },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2" }, [
                            _c(
                              "small",
                              { staticClass: "font-weight-bold text-muted" },
                              [_vm._v(_vm._s(_vm.$t("global.table.perPage")))]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "4" } },
                        [
                          _c("b-pagination", {
                            attrs: {
                              "total-rows": _vm.totalRows,
                              "per-page": _vm.perPage,
                              align: "center",
                              size: "sm",
                              pills: "",
                            },
                            on: { change: _vm.handlePageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "text-right",
                          attrs: { sm: "12", md: "12", lg: "4" },
                        },
                        [
                          _c("span", [
                            _c(
                              "small",
                              { staticClass: "text-muted font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("global.table.totalRows", {
                                      totalRows: _vm.totalRows,
                                    })
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("resumen-pagos-table", {
                staticClass: "mt-4",
                attrs: { idBeca: _vm.idBeca },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }